<div class="grid-container">
  <nav class="grid-x align-middle align-right">
    <ul class="no-bullet flex-container" *ngIf="!userLoggedIn">
      <li>
        <a class="button button--icon-on-left clear small-link" [routerLink]="[registrationLinkPath]">
          <svg class="icon icon--register icon--material" viewBox="0 0 24 24" style="width: 24px; height: 24px;">
            <use xlink:href="#icon-register" href="#icon-register"></use>
          </svg>
          <strong>{{ translate("Register") | async }}</strong>
        </a>
      </li>
      <li>
        <a class="button clear small-link" [routerLink]="[signInLinkPath]">
          <strong>{{ translate("Sign in") | async }}</strong>
        </a>
      </li>
    </ul>
    <ul class="no-bullet flex-container" *ngIf="userLoggedIn">
      <li class="icon-on-left flex-container align-middle">
        <a *ngIf="
        currentRoute !== '/' + editMyDetailsLinkPath;
        else editDetailsActive
      " class="button clear user-name" [routerLink]="[editMyDetailsLinkPath]">
          <svg class="icon icon--user" viewBox="0 0 24 24">
            <use xlink:href="#icon-user" href="#icon-user"></use>
          </svg>
          {{ userFullName }}</a>
        <ng-template #editDetailsActive>
          <div class="active user-name"><svg class="icon icon--user icon--primary-dark" viewBox="0 0 24 24">
              <use xlink:href="#icon-user" href="#icon-user"></use>
            </svg>
            {{ userFullName }}</div>
        </ng-template>
      </li>
      <li>
        <button class="button clear small-link underline" (click)="logout()">
          <strong>{{ translate("Sign out") | async }}</strong>
        </button>
      </li>
    </ul>
  </nav>
</div>